
export const EXPORT_CONTACTS = {
	OPTIONS: [
		{
			content: 'Filter profiles at the <a rel="noreferrer" target="_blank" href="https://www.linkedin.com/search/results/people/">LinkedIn search</a> and paste the URL below',
			description: 'Export profiles from the search people page of the free LinkedIn version',
			isAuthRequired: true,
			placeholder: 'https://linkedin.com/search/results/people...*',
			title: "Basic\n LinkedIn Search",
			tooltip: null,
			value: "linkedInSearch",
		},
		{
			additionalContent: 'It is important to be an attendee of a LinkedIn Event in order to filter profiles',
			content: 'Select the <a rel="noreferrer" target="_blank" href="https://www.linkedin.com/mynetwork/network-manager/events/">LinkedIn event</a> you are attending, filter through attendees, and paste the URL below',
			description: "Export attendees of the LinkedIn event you are going to attend",
			isAuthRequired: true,
			placeholder: 'https://www.linkedin.com/mynetwork/network-manager/events/',
			title: "LinkedIn\n Event Attendees",
			value: "linkedInEvent",
		},
		{
			additionalContent: 'It is important to be a member of a LinkedIn Group',
			content: 'Select the <a rel="noreferrer" target="_blank" href="https://www.linkedin.com/groups/">LinkedIn group</a> you are part of, and paste the URL below',
			description: "Export members of the LinkedIn group you are part of",
			isAuthRequired: true,
			placeholder: 'https://www.linkedin.com/groups/12740353/members/',
			title: "LinkedIn\n Group Members",
			value: "linkedInGroup",
		},
		{
			content: 'Export your <a rel="noreferrer" target="_blank" href="https://www.linkedin.com/mynetwork/invite-connect/connections/">LinkedIn Connections</a>',
			description: "Export your LinkedIn connections",
			isAuthRequired: true,
			url: 'https://www.linkedin.com/mynetwork/invite-connect/connections/',
			title: "My\n Connections",
			value: "linkedInMyConnections",
		},
		{
			content: 'Filter profiles at the <a rel="noreferrer" target="_blank" href="https://www.linkedin.com/sales/search/people">Sales Navigator Search</a> and paste the URL below',
			description: "Export profiles from the Sales Navigator search contacts page",
			isAuthRequired: true,
			isPremium: true,
			placeholder: 'https://www.linkedin.com/sales/search/people?query=(recentSearchParam%3A(id%3A4996685812%2CdoLogHistory%3Atrue)%2Cfilters%3AList((type%3AINDUSTRY%2Cvalues%3AList((id%3A15%2Ctext%3APharmaceutical%2520Manufacturing%2CselectionType%3AINCLUDED)))%2C(type%3ACOMPANY_HEADCOUNT%2Cvalues%3AList((id%3AC%2Ctext%3A11-50%2CselectionType%3AINCLUDED)))%2C(type%3AREGION%2Cvalues%3AList((id%3A102436504%2Ctext%3AZurich%252C%2520Switzerland%2CselectionType%3AINCLUDED)))%2C(type%3ACURRENT_TITLE%2Cvalues%3AList((id%3A8%2Ctext%3AChief%2520Executive%2520Officer%2CselectionType%3AINCLUDED)%2C(text%3ACEO%2CselectionType%3AINCLUDED)))))&sessionId=C1N8pv%2BkRpOTx3YWbejNSQ%3D%3D&viewAllFilters=true',
			title: "LinkedIn Sales\n Navigator Search",
			value: "salesNavigator"
		},
		{
			content: 'This export allows to export your own LinkedIn profiles list',
			description: "Export LinkedIn profiles urls from your CRM",
			placeholder: `https://www.linkedin.com/in/john-smit-123786987615876123/
https://www.linkedin.com/in/samantha-adams-987612312360123787/`,
			title: "Upload LinkedIn\n Profiles URLs",
			tooltip: 'Paste a text containing urls of LinkedIn profiles and Snaily will automatically recognize them. Once you export them you will get only profile URLs, contact details will be scraped during campaign execution.',
			value: 'linkedinProfileUrl'
		},
		{
			content: 'This export allows to export customized contacts',
			description: "Describe LinkedIn profiles on your own, add custom fields and upload",
			title: "Upload Customized\n LinkedIn Profiles",
			tooltip: 'This is advanced export that allows customizing LinkedIn profiles by changing profile information or adding custom fields. It is working only with a specific CSV file format. Please download the example to get familiar with it.',
			value: 'linkedinCustomizedProfileUrl',
		},
		{
			description: "Export profiles from the LinkedIn Recruiter search contacts page",
			isComingSoon: true,
			title: "LinkedIn\n Recruiter Search",
			value: 'recruiterSearch',
		}
	]
}